//api 接口处理
import request from "@/utils/request.js";
export default {
    //标签列表
    getLabel(param) {
        return request.post("merchant/Setting.label/labelIndex", param, false, true);
    },
    //标签分组删除
    LabelDel(param) {
        return request.post("merchant/Setting.label/groupLabelDel", param, false, true);
    },
    //标签分组排序
    groupSort(param) {
        return request.post("merchant/Setting.label/groupSort", param, false, true);
    },
    //添加企业标签
    labeAdd(param) {
        return request.post("merchant/Setting.label/labelUpdate", param, false, true);
    },

    //企业标签更新
    groupLabelUpdate(param) {
        return request.post("merchant/Setting.label/groupLabelUpdate", param, false, true);
    },
    //客户阶段列表
    gitClientList(param) {
        return request.post("merchant/Setting.phase/indexList", param, false, true);
    },
    //客户阶段更新
    imgClientUpdate(param) {
        return request.post("merchant/Setting.phase/dataUpdate", param, false, true);
    },

    //客户阶段删除
    clientDel(param) {
        return request.post("merchant/Setting.phase/dataDel", param, false, true);
    },
    //客户阶段排序
    ImgDateSort(param) {
        return request.post("merchant/Setting.phase/phaseSort", param, false, true);
    },
    //配置列表
    getMerchantConfig(param) {
        return request.post("merchant/Setting.configure/getMerchantConfig", param, false, true);
    },
    //配置保存
    setMerchantConfig(param) {
        return request.post("merchant/Setting.configure/setMerchantConfig", param, false, true);
    },
}